/* istanbul ignore file */
import { StaticFilters as Filters, ListFiltersLayout as FiltersLayout, DateTimeRangeFilter } from 'framework/list';
import React from 'react';
import { TimelineLayout, TimelinePageLayout, Timeline } from 'framework/ui/timeline';
import useCrmActivityItem from 'domain/sales/shared/timeline/activity/crmActivityRegistry';
import useCrmNoteItem from 'domain/sales/shared/timeline/note/crmNoteRegistry';
import ShowLeadPageMenu from 'domain/sales/lead/ShowLeadPageMenu';
import LeadEntityHeader from 'domain/sales/lead/LeadEntityHeader';
import { useParams } from 'react-router-dom';
import useLeadService from 'domain/sales/lead/shared/leadService';
import { Show } from 'framework/show';
import CrmTimelineEntryTypeFilter from 'domain/sales/shared/timeline/filter/CrmTimelineEntryTypeFilter';
import LeadTimelineBreadcrumbs from 'domain/sales/lead/Timeline/Breadcrumbs';

const TimelinePage = () => {
  const { id: leadId = '' } = useParams<Dictionary<string>>();
  const {
    getById,
    searchTimelineItems,
    createTimelineItem,
    getTimelinePageById,
    getFilterValidationSchema,
    pinLeadTimeline,
  } = useLeadService();

  const activityRegistry = useCrmActivityItem();
  const noteRegistry = useCrmNoteItem();

  const filters = (
    <Filters getValidationSchema={getFilterValidationSchema}>
      <FiltersLayout>
        <CrmTimelineEntryTypeFilter label="Entry type" source="type" />
        <DateTimeRangeFilter label="Created date" source="createdAt" />
      </FiltersLayout>
    </Filters>
  );
  return (
    <Show getDataMethod={() => getById(leadId)}>
      <Timeline
        registries={[noteRegistry, activityRegistry] as any}
        getDataMethod={request => searchTimelineItems(leadId, request)}
        pinTimelineAction={pinLeadTimeline}
        createTimelineItemMethod={(itemType, request) => createTimelineItem(leadId, itemType, request) as any}
        getPageByEntryIdMethod={id => getTimelinePageById(leadId, id)}
      >
        <TimelinePageLayout
          menu={<ShowLeadPageMenu />}
          breadcrumbs={<LeadTimelineBreadcrumbs />}
          entityHeader={<LeadEntityHeader />}
          filter={filters}
          titleVariant="h4"
        >
          <TimelineLayout noEntriesMessage="No entries in this lead timeline yet." />
        </TimelinePageLayout>
      </Timeline>
    </Show>
  );
};

export default TimelinePage;
